import type {DefaultOptions} from '../../types';
import type {ScannableTextValueEditorLocalizations, ScannableTextValueEditorOptions} from './types';

/**
 * @ngdoc constant
 * @name SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.scannable-text
 *
 * @description
 * For description see {@link ScannableTextValueEditorOptions}
 *
 * ```javascript
 *  {
 *      trim: false,
 *      autosubmit: false,
 *      allowedAutomaticStart: false,
 *  }
 * ```
 */
export const SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<ScannableTextValueEditorOptions> = {
    trim: false,
    autosubmit: false,
    allowedAutomaticStart: false,
};

/**
 * @ngdoc constant
 * @name SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.scannable-text
 *
 * @description
 * ```
 * {
 *      scanWithCamera: 'Scan with camera',
 *      stopScanning: 'Stop scanning',
 *      description: ''
 * }
 * ```
 */
export const SCANNABLE_TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS: Readonly<Required<ScannableTextValueEditorLocalizations>> = Object.freeze({
    scanWithCamera: 'Scan with camera',
    stopScanning: 'Stop scanning',
    description: ''
});